import React from 'react'
import {
  Checkbox,
  FormControlLabel,
  Alert,
  AlertTitle,
  List,
  ListItem,
  ListItemText
} from '@mui/material'
import AtomicButton from '../../../../atomic/button/Button'
import styles from './styles.module.css'

export const ActionFooter = ({
  editConfirmed,
  setEditConfirmed,
  fieldsToBeUpdatedUnique,
  isLoading,
  onClose,
  handleUpdateProduct
}) => (
  <div className={styles.footerWrapper}>
    <div className={styles.confirmRow}>
      <FormControlLabel
        control={
          <Checkbox
            checked={editConfirmed}
            onChange={e => setEditConfirmed(e.target.checked)}
            sx={{
              color: '#b8b5d4',
              padding: '6px',
              marginRight: '8px',
              '&.Mui-checked': { color: 'rgb(24, 20, 54)' }
            }}
          />
        }
        label='I confirm the changes I made are correct. I am ready to update this product.'
        sx={{
          margin: 0,
          flex: 1,
          alignItems: 'center',
          '& .MuiFormControlLabel-label': {
            fontSize: '13px',
            fontFamily: 'Inter Regular',
            color: 'rgb(24, 20, 54)'
          }
        }}
      />
    </div>

    {fieldsToBeUpdatedUnique.length > 0 && (
      <div className={styles.fieldsListWrapper}>
        <Alert
          severity='info'
          sx={{
            backgroundColor: '#e8f4fd',
            border: '1px solid #b8b5d4',
            color: 'rgb(24, 20, 54)',
            borderRadius: '8px'
          }}
        >
          <AlertTitle sx={{ color: 'rgb(24, 20, 54)', fontFamily: 'Inter Bold' }}>
            Fields to be updated
          </AlertTitle>
          <List dense component='ol' sx={{ listStyle: 'decimal', pl: 2.5 }}>
            {fieldsToBeUpdatedUnique.map((label, index) => (
              <ListItem key={index} disableGutters sx={{ display: 'list-item', py: 0.25 }}>
                <ListItemText
                  primary={label}
                  primaryTypographyProps={{
                    sx: { color: 'rgb(24, 20, 54)', fontSize: '13px', fontFamily: 'Inter Regular' }
                  }}
                />
              </ListItem>
            ))}
          </List>
        </Alert>
      </div>
    )}

    <div className={styles.buttonsRow}>
      <button onClick={onClose} className={styles.footerCancelBtn}>Cancel</button>
      <div className={styles.updateBtnWrapper}>
        <AtomicButton
          label='Update Product'
          handleSubmit={handleUpdateProduct}
          style={{ width: '100%', height: '48px', marginTop: 0, marginBottom: 0 }}
          loadingButtonStyle={{
            backgroundColor: '#e8e8e8',
            color: '#707070',
            border: '1px solid #d0d0d0',
            cursor: 'not-allowed'
          }}
          loading={isLoading}
          disabled={isLoading || !editConfirmed || fieldsToBeUpdatedUnique.length === 0}
        />
      </div>
    </div>
  </div>
)
